import "./Services.css";
import { React, useState, useEffect, useCallback } from 'react';
import axios from "axios";
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import FloatingLabelInput from "../Components/Table_booking/BookingForm/FloatingLabelInput";
import ReCAPTCHA from "react-google-recaptcha";
import './contactus.css'
import FooterTagSection from "../Club-aboutus/custom-comp/FooterTagSection";
import banner from "./image/contact-banner.svg"
import { Link, useNavigate } from "react-router-dom";

export default function ContactUs() {
  // Form state
  const [formData, setFormData] = useState({
    username: '',
    number: '',
    email: '',
    subject: '',
    message: ''
  });

  const userData = JSON.parse(localStorage.getItem('userData'));

  const navigate = useNavigate();

  // UI state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaRef, setCaptchaRef] = useState(null);

  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  // Handle form input changes
  const handleInputChange = useCallback((field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  // Handle captcha change
  const handleCaptchaChange = useCallback((value) => {
    setCaptchaValue(value);
  }, []);

  // Handle captcha expiry
  const handleCaptchaExpired = useCallback(() => {
    setCaptchaValue(null);
    iziToast.warning({
      title: 'Warning',
      message: 'Captcha expired. Please verify again.',
      position: 'topCenter',
    });
  }, []);

  // Handle captcha error
  const handleCaptchaError = useCallback(() => {
    setCaptchaValue(null);
    iziToast.error({
      title: 'Error',
      message: 'Captcha failed to load. Please refresh the page.',
      position: 'topCenter',
    });
  }, []);

  // Reset form
  const resetForm = useCallback(() => {
    setFormData({
      username: '',
      number: '',
      email: '',
      subject: '',
      message: ''
    });
    setCaptchaValue(null);
    if (captchaRef) {
      captchaRef.reset();
    }
  }, [captchaRef]);

  // Form validation
  const validateForm = useCallback(() => {
    const { username, number, email } = formData;

    if (!username.trim()) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Name is required.',
        position: 'topCenter',
      });
      return false;
    }

    if (!number.trim()) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Mobile number is required.',
        position: 'topCenter',
      });
      return false;
    }

    if (!/^\d{10}$/.test(number.trim())) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Please enter a valid 10-digit mobile number.',
        position: 'topCenter',
      });
      return false;
    }

    if (!email.trim()) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Email is required.',
        position: 'topCenter',
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Please enter a valid email address.',
        position: 'topCenter',
      });
      return false;
    }

    if (!captchaValue) {
      iziToast.error({
        title: 'Validation Error',
        message: 'Please complete the captcha verification.',
        position: 'topCenter',
      });
      return false;
    }

    return true;
  }, [formData, captchaValue]);

  // Handle form submission
  const handleSubmitEnquiry = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.username.trim());
      formDataToSend.append('mobile', formData.number.trim());
      formDataToSend.append('email', formData.email.trim());
      formDataToSend.append('subject', formData.subject.trim());
      formDataToSend.append('msg', formData.message.trim());
      formDataToSend.append('captcha', captchaValue);

      const response = await axios.post(
        'https://partywitty.com/master/APIs/Common/submitContact',
        formDataToSend,
      );

      if (response.data.status === true) {
        iziToast.success({
          title: 'Success',
          message: response.data.msg || 'Your message has been sent successfully! We will get back to you soon.',
          position: 'topCenter',
          timeout: 5000,
        });
        navigate('/contact-us/thank-you');
        resetForm();
      } else {
        iziToast.error({
          title: 'Error',
          message: response.data.msg || 'Failed to send your message. Please try again.',
          position: 'topCenter',
        });
        // Reset captcha on error
        if (captchaRef) {
          captchaRef.reset();
        }
        setCaptchaValue(null);
      }
    } catch (error) {
      console.error('Contact form submission error:', error);

      let errorMessage = 'An error occurred while sending your message. Please try again.';

      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Request timeout. Please check your internet connection and try again.';
      } else if (error.response) {
        errorMessage = error.response.data?.msg || 'Server error. Please try again later.';
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      iziToast.error({
        title: 'Error',
        message: errorMessage,
        position: 'topCenter',
        timeout: 7000,
      });

      // Reset captcha on error
      if (captchaRef) {
        captchaRef.reset();
      }
      setCaptchaValue(null);
    } finally {
      setIsSubmitting(false);
    }
  };


  const generateRelatedLinks = () => {

    return [
      {
        id: 1,
        url: `/events`,
        tag: `Events `,
      },
      {
        id: 2,
        url: `/events`,
        tag: "Events in Noida",
      },
      {
        id: 3,
        url: `/venues`,
        tag: `Venues in Noida`,
      },
      {
        id: 4,
        url: `/my-plan`,
        tag: `Book a Venue`,
      },
      {
        id: 5,
        url: `/table-book-form`,
        tag: `Plan Your Party Now`,
      },
      {
        id: 6,
        tag: `Events`,
      },
      {
        id: 7,
        tag: `music Dining`,
      },
      {
        id: 8,
        tag: `events`,
      },
      {
        id: 8,
        tag: `events`,
      },
      {
        id: 8,
        tag: `events`,
      },
    ];
  };

  const relatedLinks = generateRelatedLinks();

  return (

    <div className="aboutusPage">
      <section className="about--banner">
        <div className="main--box">
          <div className="title--name">
            <h3>Contact us</h3>
          </div>
        </div>
      </section>

      <section className="main--feacture">
        <div className="contact-us-page-section">
          <div className="">
            <div className="">
              <div className="">
                <form onSubmit={handleSubmitEnquiry} className="contact-us-form--box">
                  <FloatingLabelInput
                    type="text"
                    placeholder="Enter Name"
                    value={formData.username}
                    onChange={(e) => handleInputChange('username', e.target.value)}
                    label="Enter Name"
                    required
                    disabled={isSubmitting}
                  />

                  <FloatingLabelInput
                    type="tel"
                    placeholder="Enter Mobile Number"
                    value={formData.number}
                    onChange={(e) => {
                      // Only allow digits and limit to 10 characters
                      const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                      handleInputChange('number', value);
                    }}
                    label="Enter Mobile Number"
                    required
                    disabled={isSubmitting}
                    maxLength="10"
                    pattern="[0-9]{10}"
                  />

                  <FloatingLabelInput
                    type="email"
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    label="Enter Email"
                    required
                    disabled={isSubmitting}
                  />

                  <FloatingLabelInput
                    type="text"
                    placeholder="Enter Subject"
                    value={formData.subject}
                    onChange={(e) => handleInputChange('subject', e.target.value)}
                    label="Enter Subject"
                    disabled={isSubmitting}
                  />

                  <FloatingLabelInput
                    type="text"
                    placeholder="Help us know what went wrong?"
                    value={formData.message}
                    onChange={(e) => handleInputChange('message', e.target.value)}
                    label="Help us know what went wrong?"
                    disabled={isSubmitting}
                  />

                  {/* reCAPTCHA */}
                  <div className="captcha-container" style={{ margin: '20px 0' }}>
                    <ReCAPTCHA
                      ref={(ref) => setCaptchaRef(ref)}
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={handleCaptchaChange}
                      onExpired={handleCaptchaExpired}
                      onError={handleCaptchaError}
                      theme="light" // or "dark"
                      size="normal" // or "compact"
                    />
                  </div>

                  <div className="contact-us-form--button">
                    <button
                      type="submit"
                      className=""
                      disabled={isSubmitting || !captchaValue}
                      style={{
                        opacity: isSubmitting || !captchaValue ? 0.7 : 1,
                        cursor: isSubmitting || !captchaValue ? 'not-allowed' : 'pointer',
                        position: 'relative'
                      }}
                    >
                      {isSubmitting ? (
                        <>
                          <span style={{ marginRight: '8px' }}>Sending...</span>
                          <div
                            style={{
                              display: 'inline-block',
                              width: '16px',
                              height: '16px',
                              border: '2px solid #ffffff',
                              borderRadius: '50%',
                              borderTopColor: 'transparent',
                              animation: 'spin 1s linear infinite'
                            }}
                          ></div>
                        </>
                      ) : (
                        'Send Message'
                      )}
                    </button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>



        <div className="contact-us-detail-page-design-bottom-details">
          <div className="contact-us-detail-page-design-bottom-details-contact">
            <div className="contact-us-detail-page-design-bottom-details-1">
              <b>Phone No: </b>
              <a href='tel:+918299619469' style={{ color: '#007bff', textDecoration: 'none' }}>
                +91 8299619469
              </a>
            </div>
            <div className="contact-us-detail-page-design-bottom-details-1">
              <b>Email ID: </b>
              <a href='mailto:sayhello@partywitty.com' style={{ color: '#007bff', textDecoration: 'none' }}>
                sayhello@partywitty.com
              </a>
            </div>
          </div>
          <div className="contact-us-detail-page-design-bottom-details-1">
            <b>Registered Address:</b>
            <br />
            <span>
              AMIRAG HOSPITALITY PVT. LTD
              E-153, UPPER GF, LEFT SIDE VISHKARMA COLONY
              DELHI, India - 110044
            </span>
          </div>
        </div>

      


        <div className='contact-us-detail-page-design-bottom-footer-tags-section'>
          {/* <h1>You May Also Like This</h1> */}
          <div className='contact-us-detail-page-design-bottom-footer-tags'>
            <div className='contact-us-detail-page-design-bottom-footer-tags-text'>
              <h1>Book the Best Party Venues, Bars, Cafes & Lounges in Delhi-NCR</h1>
              <p>Top-rated party venues, bars, cafés, and lounges in Delhi, Noida, and Gurgaon for birthdays, corporate parties, kitty parties, and weekend hangouts. Whether you're looking for rooftop lounges, live music cafés, dance floors, or themed party halls, find the perfect place that fits your vibe and budget. Compare packages, explore curated party deals, and book instantly with PartyWitty. Enjoy exclusive offers on private party spaces, couple-friendly lounges, and group bookings across Delhi-NCR. Make your celebrations memorable by booking verified venues with custom food and drink options. Plan your next party effortlessly with our trusted event booking platform. </p>
            </div>
            <div className='contact-us-detail-page-design-bottom-footer-tags-text'>
              <h1>Book a Table Instantly at Restaurants, Clubs & Pubs Near You with the Best Offers</h1>
              <p>Book a table instantly at the best restaurants, clubs, and pubs near you with PartyWitty. Whether it's a birthday, anniversary, corporate event, or casual night out, find the perfect venue that suits your vibe. Explore top-rated places across Delhi-NCR, compare deals, check availability, and reserve your spot in just a few clicks. Get access to exclusive table booking offers and save up to 50% on your party experience. From rooftop lounges to BYOB venues, PartyWitty helps you plan the perfect outing without the hassle. Book now and party your way — effortlessly and affordably.</p>
            </div>
            <div className='contact-us-detail-page-design-bottom-footer-tags-text'>
              <h1> Explore Custom Party Packages with Exclusive Deals & Offers</h1>
              <p>Planning a celebration? PartyWitty helps you explore and book custom party packages at top restaurants, clubs, and lounges across Delhi, Noida, and Gurgaon. Whether it's a birthday, anniversary, corporate event, or a casual get-together, find the perfect venue that suits your style and budget. Get up to 50% off on exclusive deals, including rooftop lounges, BYOB venues, and dance floors. Customize food and drink menus, check real-time availability, and compare verified listings — all in one place. With PartyWitty, party planning becomes quick, flexible, and effortless. Book now and enjoy unforgettable moments stress-free!</p>
            </div>
          </div>
          <FooterTagSection relatedLinks={relatedLinks} clubInfo={"partywitty"} />
        </div>
      </section>



      {/* Add spinner animation styles */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}